import React, { useCallback, useContext } from "react"
import { NumericFormat, NumericFormatProps } from "react-number-format"
import { CustomFieldContext } from "../contexts/CustomConfigContext"

export interface NumberEditProps extends Omit<NumericFormatProps, "onChange" | "value" | "id"> {
    id?: string
    value: number | null
    onChange?: (value: number | null) => void
    readonly?: boolean
    addOnText?: string
    decimalPrecision?: number
}

export function NumberEdit({ addOnText, suffix = "", disabled, ...rest }: NumberEditProps) {
    const customFieldContext = useContext(CustomFieldContext)
    const disabledCustom = customFieldContext?.disabled ?? disabled

    if (!addOnText) {
        return <Input suffix={suffix} disabled={disabledCustom} {...rest} />
    }

    return (
        <div className="input-group">
            <Input suffix={suffix} disabled={disabledCustom} {...rest} />
            <div className="input-group-addon">{addOnText}</div>
        </div>
    )
}

const Input = ({ readonly, value, onChange, decimalPrecision, ...rest }: NumberEditProps) => {
    const onChangeHandler = useCallback(
        (event: any) => {
            let newValue: number | null = parseFloat(event?.target?.value)
            if (isNaN(newValue)) {
                newValue = null
            }
            if (onChange) {
                onChange(newValue)
            }
        },
        [onChange],
    )

    const notNullableValue = value === null ? "" : value

    return (
        <NumericFormat
            className="form-control"
            decimalScale={decimalPrecision ?? 2}
            decimalSeparator=","
            thousandSeparator="."
            fixedDecimalScale
            disabled={Boolean(readonly)}
            readOnly={Boolean(readonly)}
            value={notNullableValue !== null && notNullableValue !== undefined ? notNullableValue : ""}
            onValueChange={(values) => {
                onChangeHandler({
                    target: {
                        value: values.value,
                    },
                })
            }}
            allowLeadingZeros={false}
            valueIsNumericString
            {...rest}
        />
    )
}
